import React from 'react';
import { ShieldCheck, AlertTriangle } from 'lucide-react';

export const ObstacleDataTable = ({ obstacles }) => {
    if (!obstacles || obstacles.length === 0) {
        return (
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 text-center flex flex-col items-center">
                <ShieldCheck className="h-12 w-12 text-gray-400 mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">No se detectaron choques directos en el escaneo automatizado preliminar (Fase 1 - Criterios Conservadores).</h3>
                <p className="text-gray-500 max-w-lg text-sm">
                    Este resultado no garantiza registrabilidad. El sistema recomienda encarecidamente una revisión analítica manual en la plataforma oficial del IMPI antes de proceder con cualquier solicitud.
                </p>
            </div>
        );
    }

    return (
        <div className="bg-white rounded-xl shadow overflow-hidden border border-gray-200 mb-8">
            <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-2">
                <AlertTriangle className="h-5 w-5 text-yellow-500" />
                <h3 className="text-lg font-semibold text-gray-900">
                    Obstáculos Encontrados
                </h3>
            </div>
            <div className="p-4 bg-yellow-50 text-yellow-800 border-b border-yellow-200 text-sm">
                El escaneo preliminar ha detectado posibles coincidencias fonéticas o gramaticales. Se requiere evaluación técnica minuciosa para determinar viabilidad legal de registro.
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Marca Encontrada</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Clase</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Estatus IMPI</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tipo Similitud</th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Puntuación</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {obstacles.map((obs, idx) => (
                            <tr key={idx} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                    {obs.found_name}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {obs.class_number}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    {obs.status || 'N/A'}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                    <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded text-xs">
                                        {obs.similarity_type}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-700">
                                    {obs.base_score.toFixed(1)} / 10
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
